export const environment = {
    production: true,
    key: 'a9c4cef5735770e657b7c25b9dcb807b',
    host: 'https://api3.wesoon.net',
    api: '/api',
    aMapApiKey: '107443083c5a7d5cdc9d4b5efc697fc9',
};
